export const INITIAL_CREATE_MISSION_DATA = {
  company: null,
  idLocation: null,
  activity: '',
  qualification: '',
  title: '',
  tools: [],
  licences: [],
  languages: [],
  contact_name: '',
  contact_poste: 'Responsable',
  location: '',
  dateStart: '',
  dateEnd: '',
  schedule: [],
  isScheduleCheck: true,
  isConfirmedSchedule: false,
  isScheduleRequired: false,
  users_invite: [],
  motif: '',
  other: '',
  other_interim: '',
  salary: '',
  inviteType: '',
  vivierStatus: [],
  vivierSelections: [],
  globalNotificationRequested: false,
  user_assigned: {},
  reference: '',
  companyName: '',
  // The job description the mission starts from, as the API returned it.
  missionTemplate: null,
};

const isEmptyComparableValue = (value) => {
  if (value == null || value === '') return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
};

const normalizeComparableValue = (value) => {
  if (isEmptyComparableValue(value)) return null;

  if (Array.isArray(value)) {
    const normalizedItems = value
      .map(normalizeComparableValue)
      .filter((item) => item != null);
    return normalizedItems.length ? normalizedItems : null;
  }

  if (typeof value === 'object') {
    const normalizedEntries = Object.entries(value)
      .map(([key, nestedValue]) => [key, normalizeComparableValue(nestedValue)])
      .filter(([, nestedValue]) => nestedValue != null)
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));

    if (!normalizedEntries.length) return null;
    return Object.fromEntries(normalizedEntries);
  }

  return value;
};

const areComparableValuesEqual = (left, right) =>
  JSON.stringify(normalizeComparableValue(left)) ===
  JSON.stringify(normalizeComparableValue(right));

export const hasChangesSinceBaseline = (current, baseline) =>
  !areComparableValuesEqual(current, baseline);

// These panels ask first when they report unsaved changes.
const CLOSE_CONFIRM_MESSAGE_KEYS = {
  add_mission: 'slideOverCloseConfirm.addMission',
  add_company: 'slideOverCloseConfirm.addCompany',
  qualification: 'slideOverCloseConfirm.qualification',
};

const SLIDE_OVERS_CONFIRMING_CLOSE = Object.keys(CLOSE_CONFIRM_MESSAGE_KEYS);

/**
 * Whether the slide-over may close: nothing typed in a creation or a
 * qualification would be lost, or the admin agrees to lose it. Every way of
 * closing one asks the same.
 */
export const confirmSlideOverClose = (
  slideOverType,
  hasUnsavedChanges,
  language,
) =>
  !(
    SLIDE_OVERS_CONFIRMING_CLOSE.includes(slideOverType) && hasUnsavedChanges
  ) ||
  window.confirm(language.getValue(CLOSE_CONFIRM_MESSAGE_KEYS[slideOverType]));
